export interface ClusteringParams {
  kMeansParams: {
    minK: number;
    maxK: number;
  };
  neighborCountParams: {
    nNeighbors: number;
    normalizeCounts: boolean;
    arcsinhNormalizationCoFactor: number;
    addSelfCellToNeighborCounts: boolean;
  };
}

export interface SamplingParams {
  // The absolute maximum number of cells to sample per slide.
  absoluteMaxCellsPerSlide: number;
  // The maximum fraction of cells per class to sample per slide.
  maxCellsFractionPerSlide: number;
  // List of cell classes to exclude from sampling
  cellClassesToExclude: string[] | null;
  // If True, perform weighted sampling of cell classes. Otherwise, randomly sample the calculated number of cells from the whole slide.
  weightedSamplingOfCellClasses: boolean;
  // If True, perform balanced sampling of cell classes, i.e. sample 1/f per cell class per slide, where f is the fraction of that cell class in the slide.
  // This option is only valid if weighted_sampling_of_cell_classes is False.
  balancedSamplingOfCellClasses: boolean;
}

export interface NeighborhoodClustersJobConfig {
  cellTableArtifactUrls: string[];
  clusteringParams: ClusteringParams[];
  // Parameters for sampling cells in a manifest level cell table.
  samplingParams: SamplingParams;
}

export interface NeighborhoodClustersFormValues {
  jobName: string;
  jobDescription: string;
  configParams: NeighborhoodClustersJobConfig;
}

export enum RunNeighborhoodClustersStep {
  NameAndDescription = 'Name and Description',
  SetUpCellTableInputs = 'Setup Cell Table inputs',
  ClusteringParameters = 'Clustering Parameters',
  SamplingParameters = 'Sampling Parameters',
}

export const runNeighborhoodClustersOrder = [
  RunNeighborhoodClustersStep.NameAndDescription,
  RunNeighborhoodClustersStep.SetUpCellTableInputs,
  RunNeighborhoodClustersStep.ClusteringParameters,
  RunNeighborhoodClustersStep.SamplingParameters,
];
